import { Tile, NUM_TILE_TYPES } from './tiles';
import { makeRng, shuffle } from './rng';

/** 34종 × 4장 = 136장, 종류 오름차순 정렬. */
export function buildWall(): Tile[] {
  const wall: Tile[] = [];
  for (let t = 0; t < NUM_TILE_TYPES; t++) {
    for (let i = 0; i < 4; i++) wall.push(t);
  }
  return wall;
}

/** 시드로 결정적으로 섞은 패산. */
export function shuffleWall(seed: string): Tile[] {
  return shuffle(buildWall(), makeRng(seed));
}

export interface Deal {
  hands: Tile[][]; // 4인, 각 13장
  wall: Tile[];    // 남은 산 (위에서부터 draw)
}

/** 4인에게 13장씩 분배하고 나머지를 산으로 남긴다.
 *  (장수만 정확한 단순 분배. 실제 4-4-4-1 배패 순서는 Phase 2에서.) */
export function deal(seed: string): Deal {
  const shuffled = shuffleWall(seed);
  const hands: Tile[][] = [[], [], [], []];
  let idx = 0;
  for (let p = 0; p < 4; p++) {
    for (let i = 0; i < 13; i++) hands[p].push(shuffled[idx++]);
  }
  const wall = shuffled.slice(idx);
  return { hands, wall };
}
